import { getCurrentTheme } from "@/utils/util";
import { UI_THEMES } from "@/utils/const";
import ThemeSelector from "@/components/common/ThemeSelector.vue";
import LanguageSelector from "@/components/common/LanguageSelector.vue";
import Button from "primevue/button";
import CommandKSearch from "@/components/search/CommandKSearch.vue";
import { ConfirmDialog } from "primevue";
export default {
  name: "TopMenu",
  components: {
    CommandKSearch: CommandKSearch,
    LanguageSelector: LanguageSelector,
    ThemeSelector: ThemeSelector
  },
  computed: {
    logo: function logo() {
      return getCurrentTheme() === UI_THEMES.DARK ? process.env.VUE_APP_MENU_LOGO_DARK : process.env.VUE_APP_MENU_LOGO;
    },
    breadcrumbs: function breadcrumbs() {
      var meta = this.$route.meta;
      return typeof meta.breadcrumb === "function" ? meta.breadcrumb(this.$route) : meta.breadcrumb || [];
    }
  }
};